export const GET_VOUCHERS_PENDING = "GET_VOUCHERS_PENDING"
export const GET_VOUCHERS_SUCCESS = "GET_VOUCHERS_SUCCESS"
export const GET_VOUCHERS_FAILURE = "GET_VOUCHERS_FAILURE"

export const ADD_VOUCHERS_PENDING = "ADD_VOUCHERS_PENDING"
export const ADD_VOUCHERS_SUCCESS = "ADD_VOUCHERS_SUCCESS"
export const ADD_VOUCHERS_FAILURE = "ADD_VOUCHERS_FAILURE"

export const UPLOAD_VOUCHERS_PENDING = "UPLOAD_VOUCHERS_PENDING"
export const UPLOAD_VOUCHERS_SUCCESS = "UPLOAD_VOUCHERS_SUCCESS"
export const UPLOAD_VOUCHERS_FAILURE = "UPLOAD_VOUCHERS_FAILURE"

export const EDIT_VOUCHERS_PENDING = "EDIT_VOUCHERS_PENDING"
export const EDIT_VOUCHERS_SUCCESS = "EDIT_VOUCHERS_SUCCESS"
export const EDIT_VOUCHERS_FAILURE = "EDIT_VOUCHERS_FAILURE"

export const DELETE_VOUCHERS_PENDING = "DELETE_VOUCHERS_PENDING"
export const DELETE_VOUCHERS_SUCCESS = "DELETE_VOUCHERS_SUCCESS"
export const DELETE_VOUCHERS_FAILURE = "DELETE_VOUCHERS_FAILURE"

export const DOWNLOAD_VOUCHERS_PENDING = "DOWNLOAD_VOUCHERS_PENDING"
export const DOWNLOAD_VOUCHERS_SUCCESS = "DOWNLOAD_VOUCHERS_SUCCESS"
export const DOWNLOAD_VOUCHERS_FAILURE = "DOWNLOAD_VOUCHERS_FAILURE"